import React from 'react';
import { Row, Col, Typography, Space, Button, Breadcrumb, Alert } from 'antd';
import { SaveOutlined, PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';

const { Title } = Typography;

const TemplateHeader = ({
    id,
    handleGoBack,
    handleSaveTemplate,
    saving,
    isTemplateActive,
    handleActivateTemplate,
    handleDeactivateTemplate,
    activating,
    isScheduled = false // 新增参��，用于区分是否是定时SOP
}) => {
    // 根据是否是定时SOP来确定标题和返回按钮文本
    const getPageTitle = () => {
        const action = id && id !== 'new' ? '编辑' : '创建';
        const type = isScheduled ? '聚合群发' : '智能体';
        return `${action}${type}`;
    };

    const getBreadcrumbText = () => {
        return isScheduled ? '聚合群发' : '智能体';
    };

    return (
        <div>
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                <Col>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleGoBack}>
                            <Title level={5} style={{ cursor: 'pointer', color: '#1677ff', margin: 0 }}>{getBreadcrumbText()}</Title>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Title level={5} style={{ margin: 0 }}>{getPageTitle()}</Title>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col>
                    <Space>
                        {/* ���有在编辑模式下才显示激活/禁用按钮 */}
                        {id && id !== 'new' && (
                            <>
                                {isTemplateActive() ? (
                                    <Button
                                        icon={<PauseCircleOutlined />}
                                        onClick={handleDeactivateTemplate}
                                        loading={activating}
                                        type="default"
                                    >
                                        禁用
                                    </Button>
                                ) : (
                                    <Button
                                        type="dashed"
                                        icon={<PlayCircleOutlined />}
                                        onClick={handleActivateTemplate}
                                        loading={activating}
                                    >
                                        激活
                                    </Button>
                                )}
                            </>
                        )}
                        
                        <Button
                            type="primary"
                            icon={<SaveOutlined />}
                            onClick={handleSaveTemplate}
                            loading={saving}
                            disabled={isTemplateActive()}
                            title={isTemplateActive() ? "模板处于激活状态，请先停用" : ""}
                        >
                            保存
                        </Button>
                    </Space>
                </Col>
            </Row>

            {isTemplateActive() && (
                <Alert
                    message="提示：模板只读模式"
                    description="如需修改，请先将模板状态改为草稿或停用状态。"
                    type="warning"
                    showIcon
                    style={{ marginBottom: '12px', padding: '10px 24px', border: 'none'  }}
                />
            )}
        </div>
    );
};

export default TemplateHeader;
